package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Learn
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.CourseState
import org.jetbrains.compose.web.css.px

@Composable
fun CourseAccordionContent(
    onComplete: (String) -> Unit,
    onAddCourseAndClose: (String) -> Unit
) {
    val cvViewModel = koinGet<CvViewModel>()
    val coursesFromVM = cvViewModel.cvUiState.data.learns

    LaunchedEffect(Unit) {
        if (coursesFromVM.isEmpty()) {
            cvViewModel.updateCourse(0, Learn("", "", "", ""))
            cvViewModel.editingCourseId = "course-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        coursesFromVM.forEachIndexed { index, learn ->
            val tempId = "course-$index"

            val courseState = remember(learn) {
                val dateParts = learn.started.split("-")
                CourseState(
                    id = tempId,
                    cours = learn.label,
                    mois = dateParts.getOrNull(0) ?: "",
                    annee = dateParts.getOrNull(1) ?: "",
                    isOngoing = learn.started == "En cours",
                    description = learn.description
                )
            }

            GenericFormCard(
                item = courseState,
                isEditing = cvViewModel.editingCourseId == tempId,
                onEdit = { cvViewModel.editingCourseId = tempId },
                onDelete = {
                    cvViewModel.deleteCourse(index)
                    if (cvViewModel.cvUiState.data.learns.isEmpty()) {
                        cvViewModel.updateCourse(0, Learn("", "", "", ""))
                        cvViewModel.editingCourseId = "course-0"
                    } else {
                        cvViewModel.editingCourseId = null
                    }
                },
                onComplete = { cvViewModel.editingCourseId = null },
                getSummary = { c ->
                    if (c.cours.isNotBlank()) {
                        val periode = if (c.isOngoing) "En cours" else "${c.mois} ${c.annee}".trim()
                        SummaryData(title = c.cours, subtitle = periode)
                    } else null
                },
                getDefaultText = { "[Cours]" },
                formContent = { state, onDel, onComp ->
                    CourseForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp,
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter un cours",
            onClick = {
                val nextIndex = coursesFromVM.size
                cvViewModel.updateCourse(nextIndex, Learn("", "", "", ""))
                cvViewModel.editingCourseId = "course-$nextIndex"
            }
        )
    }
}